import { IRootState } from '../../../../store'
import { IOperationsState } from '../store/operations.types'

export const getOperationsSelector = (state: IRootState): IOperationsState => state.operations
